import React from 'react';
import { I18n } from 'react-redux-i18n';


export const TIME_TYPE_BOOK_VALUE = {
	PICKUP: 'pickup',
	COMPLETED: 'completed',
}
const optionsTime = [
	{ value: TIME_TYPE_BOOK_VALUE.PICKUP, label: 'generalSetting.pickupTime' },
	{ value: TIME_TYPE_BOOK_VALUE.COMPLETED, label: 'invoice.completedTime' },
]

const TimeTypeBookSelect = ({
	value,
	onChange,
	disabled,
	style,
	isTextActiveColor
}) => {
	return (
		<select
			className="form-control form-custom"
			onChange={onChange}
			value={value}
			disabled={disabled}
			tabIndex={-1}
			style={{ 
				width: 'auto',
				backgroundColor: '#363a44',
				...(isTextActiveColor ? { color: '#04BE76' } : {}),
				...(style || {})
			}}
		>
			{optionsTime.map((option) => (
				<option key={option.value} value={option.value}>
					{I18n.t(option.label)}
				</option>
			))}
		</select>
	);
};

export default TimeTypeBookSelect;
